import { createReactExtension } from '@backstage/core-plugin-api';
import motivationalQuotes from './motivationalQuotes';
import { Typography } from '@material-ui/core';
import { useStyles } from './header.style';

import { homePlugin, WelcomeTitle } from '@backstage/plugin-home';
import { useEffect, useState } from 'react';

const timeFormat: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

export const HeaderHomePage = () => {
  const { cx, classes } = useStyles();
  const [time, setTime] = useState<{ [key: string]: string }>({});
  const [motivation, setMotivation] = useState<string>('');

  const flags = {
    ireland: <svg className={cx(classes.flagIreland, classes.flag)} />,
    belgium: <svg className={cx(classes.flagBelgium, classes.flag)} />,
    switzerland: <svg className={cx(classes.flagSwitzerland, classes.flag)} />,
    germany: <svg className={cx(classes.flagGermany, classes.flag)} />,
    india: <svg className={cx(classes.flagIndia, classes.flag)} />,
  };

  const clockConfigs = [
    { flag: flags.ireland, timeZone: 'Europe/Dublin' },
    {
      flag: (
        <>
          {flags.belgium} {flags.switzerland} {flags.germany}
        </>
      ),
      timeZone: 'Europe/Brussels',
    },
    { flag: flags.india, timeZone: 'Asia/Kolkata' },
  ];

  const getRandomMotivation = () => {
    return motivationalQuotes[
      Math.floor(Math.random() * motivationalQuotes.length)
    ];
  };

  useEffect(() => {
    const updateClock = () => {
      const newTime: { [key: string]: string } = {};
      clockConfigs.forEach(clock => {
        const clockTime = new Date().toLocaleTimeString('en-US', {
          timeZone: clock.timeZone,
          ...timeFormat,
        });
        newTime[clock.timeZone] = clockTime;
      });
      setTime(newTime);
    };

    updateClock();
    const interval = setInterval(updateClock, 1000); // Updates every second

    setMotivation(getRandomMotivation());

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderClocks = clockConfigs.map((clock, index) => (
    <div key={index}>
      <span>{clock.flag}</span>
      <span>{time[clock.timeZone]}</span>
    </div>
  ));

  return (
    <article className={cx(classes.header)} data-testid="header-home-page">
      <Typography variant="h6">
        <WelcomeTitle language={['English']} /> {motivation}
      </Typography>

      <section>{renderClocks}</section>
    </article>
  );
};

export const HeaderHomePageWidget = homePlugin.provide(
  createReactExtension({
    name: 'HomePage Header',
    component: {
      lazy: () => import('./Header').then(m => m.HeaderHomePage),
    },
    data: {
      'home.widget.config': {
        layout: {
          width: { defaultColumns: 12, minColumns: 12, maxColumns: 12 },
          height: { defaultRows: 1, minRows: 1, maxRows: 1 },
        },
      },
    },
  }),
);
